import './NewTemplate.scss'
import { useState, SyntheticEvent } from 'react'
import React, { useRef } from 'react'
import { Editor } from '@tinymce/tinymce-react'
import { Button, FormHelperText, Input, Typography } from '@mui/material'
import InputAdornment from '@mui/material/InputAdornment'
import useTemplate from '../../hooks/useTemplate'
import { useNavigate } from 'react-router-dom'

const validations: any = {
  name: (value: string) => {
    let message: string | undefined
    if (!value) {
      message = 'El nombre es obligatorio'
    }
    return message
  },
  content: (value: string) => {
    let message: string | undefined
    if (!value) {
      message = 'El contenido para la plantilla es obligatorio'
    }
    return message
  }
}

function TemplateForm() {
  const { template, setTemplate, createTemplate } = useTemplate()
  const [errors, setErrors] = useState<any>({})
  const [touched, setTouched] = useState({})
  const navigate = useNavigate()

  const handleChange = (name: string, value: string) => {
    setTemplate({ ...template, [name]: value })
    setErrors({
      ...errors,
      [name]: validations[name] ? validations[name](value) : undefined
    })
  }

  const handleBlur = (
    event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = event.target
    setTouched({ ...touched, [name]: true })
    setErrors({
      ...errors,
      [name]: validations[name] ? validations[name](value) : undefined
    })
  }

  const isFormValid = () => {
    const validatedValues = {
      ...errors,
      name: validations.name(template.name),
      content: validations.content(template.content)
    }
    setErrors(validatedValues)

    return (
      Object.values(validatedValues).find((value) => value !== undefined) ===
      undefined
    )
  }

  const handleSubmit = async (event: SyntheticEvent) => {
    event.preventDefault()

    if (isFormValid()) {
      const newTemplate = await createTemplate(template)
      navigate(`/template/${newTemplate.id}`)
    }
  }

  const editorRef: React.MutableRefObject<null | any> = useRef(null)

  return (
    <div className="new-template">
      <Typography variant="h4">Nueva Plantilla</Typography>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <Typography>Name:</Typography>
          <Input
            type="text"
            name="name"
            value={template.name}
            onBlur={handleBlur}
            onChange={(event) =>
              handleChange(
                (event.target as HTMLInputElement).name,
                (event.target as HTMLInputElement).value
              )
            }
          />
          {errors.name && (
            <FormHelperText id="component-error-text">
              {errors.name}
            </FormHelperText>
          )}
        </div>

        <div className="form-group">
          <Typography>Content:</Typography>
          <Editor
            value={template.content}
            onInit={(evt, editor) => (editorRef.current = editor)}
            apiKey="uc3j77dzy86pi6ry0msw7s1u0km3pnhr2j98ct83vs9rahei"
            init={{
              height: 500,
              menubar: true,
              plugins: 'codesample code',
              codesample_languages: [
                { text: 'HTML/XML', value: 'markup' },
                { text: 'JavaScript', value: 'javascript' },
                { text: 'CSS', value: 'css' }
              ],
              toolbar: 'codesample code'
            }}
            textareaName="content"
            onEditorChange={(newValue) => handleChange('content', newValue)}
          />
          {errors.content && (
            <FormHelperText id="component-error-text">
              {errors.content}
            </FormHelperText>
          )}
        </div>
        <div className="form-group">
          <Typography>Header:</Typography>
          <Editor
            value={template.header}
            onInit={(evt, editor) => (editorRef.current = editor)}
            apiKey="uc3j77dzy86pi6ry0msw7s1u0km3pnhr2j98ct83vs9rahei"
            init={{
              height: 300,
              menubar: true,
              plugins: 'codesample code',
              codesample_languages: [
                { text: 'HTML/XML', value: 'markup' },
                { text: 'JavaScript', value: 'javascript' },
                { text: 'CSS', value: 'css' }
              ],
              toolbar: 'codesample code'
            }}
            textareaName="header"
            onEditorChange={(newValue) => handleChange('header', newValue)}
          />
        </div>
        <div className="form-group">
          <Typography>Footer:</Typography>
          <Editor
            value={template.footer}
            onInit={(evt, editor) => (editorRef.current = editor)}
            apiKey="uc3j77dzy86pi6ry0msw7s1u0km3pnhr2j98ct83vs9rahei"
            init={{
              height: 300,
              menubar: true,
              plugins: 'codesample code',
              codesample_languages: [
                { text: 'HTML/XML', value: 'markup' },
                { text: 'JavaScript', value: 'javascript' },
                { text: 'CSS', value: 'css' }
              ],
              toolbar: 'codesample code',
              content_style:
                'body { font-family:Montserrat; font-size:16px, color: #263145 }'
            }}
            textareaName="footer"
            onEditorChange={(newValue) => handleChange('footer', newValue)}
          />
        </div>
        <div className="form-group">
          <Typography>Header Height:</Typography>
          <Input
            type="text"
            name="headerHeight"
            value={template.headerHeight}
            onBlur={handleBlur}
            onChange={(event) =>
              handleChange(
                (event.target as HTMLInputElement).name,
                (event.target as HTMLInputElement).value
              )
            }
            endAdornment={<InputAdornment position="start">px</InputAdornment>}
          />
        </div>
        <div className="form-group">
          <Typography>Footer Height:</Typography>
          <Input
            type="text"
            name="footerHeight"
            value={template.footerHeight}
            onBlur={handleBlur}
            onChange={(event) =>
              handleChange(
                (event.target as HTMLInputElement).name,
                (event.target as HTMLInputElement).value
              )
            }
            endAdornment={
              <InputAdornment position="start" sx={{ color: 'primary.main' }}>
                px
              </InputAdornment>
            }
          />
        </div>
        <Button type="submit">Crear Plantilla</Button>
      </form>
    </div>
  )
}
export default TemplateForm
